import { toast } from 'react-toastify';

// Notificações padronizadas do projeto (sucesso / atenção / erro / info).
// Use diretamente: notify.sucesso('...'), notify.aviso('...'), notify.erro('...').
export const notify = {
  sucesso: (msg, opts) => toast.success(limpar(msg), opts),
  aviso:   (msg, opts) => toast.warning(limpar(msg), opts),
  erro:    (msg, opts) => toast.error(limpar(msg), opts),
  info:    (msg, opts) => toast.info(limpar(msg), opts),
};

const limpar = (m) => String(m == null ? '' : m).replace(/^[\u{1F5D1}\u{1F4E6}\s]+/u, '').trim() || String(m || '');

// Ponte para o padrão antigo: interpreta mensagens com emoji () e
// dispara o toast do tipo certo. Permite migrar páginas que usam setMensagem(...)
// apenas adicionando: useEffect(() => notificar(mensagem), [mensagem]);
export const notificar = (msg) => {
  if (!msg) return;
  const s = String(msg).trim();
  if (!s) return;
  // 1) Emoji explícito tem prioridade. Construídos via fromCodePoint (nunca literais):
  //    um save em ANSI já corrompeu os literais deste arquivo — viravam '' e
  //    includes('') é sempre true, então TODA mensagem caía no toast vermelho de erro.
  const E = (cp) => String.fromCodePoint(cp);
  if (s.includes(E(0x274C)) || s.includes(E(0x1F6AB))) return notify.erro(s);    // X vermelho / proibido
  if (s.includes(E(0x26A0))) return notify.aviso(s);                             // triangulo de atencao
  if (s.includes(E(0x2705)) || s.includes(E(0x2714))) return notify.sucesso(s);  // check verde / check
  if (s.includes(E(0x2139)) || s.includes(E(0x1F552))) return notify.info(s);    // info / relogio
  // 2) Heurística por palavras-chave (para mensagens sem emoji)
  const low = s.toLowerCase();
  if (/(erro|falha|n[ãa]o foi poss|inv[áa]lid|negad|expirad|recusad|falhou)/.test(low)) return notify.erro(s);
  if (/(aten[çc][ãa]o|informe|preencha|selecione|obrigat|j[áa] existe|aviso|cuidado|aguardando|pendente)/.test(low)) return notify.aviso(s);
  if (/(sucesso|salv[oa]|criad|atualizad|exclu[íi]|removid|enviad|conclu[íi]|gerad|importad)/.test(low)) return notify.sucesso(s);
  return notify.info(s);
};

export default notify;
